import React, { useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  MenuItem
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormAddMarketer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [data, setData] = useState({
    name: "",
    platform: "",
    identifier: "",
    default_message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();
    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Marketers.Add,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Marketers");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          {/* Name Field */}
          <TextField
              fullWidth
              margin="normal"
              label="Name"
              name="name"
              required
              autoComplete="off"
              value={data.name}
              onChange={handleInputChange}
              variant="outlined"
          />

          {/* Platform Select Dropdown */}
          <TextField
              select
              fullWidth
              margin="normal"
              label="Platform"
              name="platform"
              required
              value={data.platform}
              onChange={handleInputChange}
              variant="outlined"
          >
            <MenuItem value="whatsapp">WhatsApp</MenuItem>
            <MenuItem value="telegram">Telegram</MenuItem>
          </TextField>

          {/* Identifier Field */}
          <TextField
              fullWidth
              margin="normal"
              label="Identifier"
              name="identifier"
              required
              autoComplete="off"
              value={data.identifier}
              onChange={handleInputChange}
              variant="outlined"
              helperText={
                data.platform === "whatsapp"
                    ? "Phone number (include country code)"
                    : "Telegram username"
              }
          />

          {/* Default Message Field */}
          <TextField
              fullWidth
              margin="normal"
              label="Default Message"
              name="default_message"
              required
              autoComplete="off"
              value={data.default_message}
              onChange={handleInputChange}
              variant="outlined"
          />
        </div>

        {/* Submit Button */}
        <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isLoadingSubmit}
            color="primary"
            sx={{
              display: isLoadingSubmit ? "flex" : "block",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
          ) : (
              "Add Contact"
          )}
        </Button>
      </form>
  );
};